module.exports = __webpack_public_path__ + "static/media/data.e81dadf0.svg";